import { UserService } from "@/store/modules/user";

export const unauthenticatedState = {
  isConnected: false,
  isMember: false,
  isAdmin: false,
};

export async function getAuthenticatedState(user) {
  const userRoles = await UserService.actions.getUserRoles(user.uid);
  const searchCriterias = await UserService.actions.getUserFiltersByUid(user.uid);

  let isMember = userRoles.isMember;
  let membershipEndDate = userRoles.membershipEndDate;

  if (!isMember) {
    const res = await UserService.actions.syncMembershipForUser(user);
    if (res && res.isMember) {
      isMember = true;
      membershipEndDate = res.endDate || membershipEndDate;
    }
  }

  return {
    isConnected: true,
    isMember,
    membershipEndDate,
    isAdmin: userRoles.isAdmin,
    searchCriterias,
  };
}
